// This build is the retired version kept for consultation only: it searches and
// shows history, and sends every account, plan and payment action to the new app.
export const NEW_APP_URL = "https://doctia.com.ar";
